import script from "./NavigationFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavigationFooter.vue?vue&type=script&lang=ts&setup=true"

import "./NavigationFooter.vue?vue&type=style&index=0&id=722a9b46&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-722a9b46"]])

export default __exports__